
define('text!vb/types/instanceFactory/builtinTypes.json',[],function () { return '{"types":{"vb/ServiceDataProvider2":{"typeDef":"./vbServiceDataProvider2/index.d.ts"},"vb/MultiServiceDataProvider2":{"typeDef":"./vbMultiServiceDataProvider2/index.d.ts"}}}';});

